<template>
  <div class="home">
    <Swiper1></Swiper1>
    <div class="news">
      <div class="title">
        <h3>最新消息</h3>
        <div
          class="more"
          @click="expMore"
          @mouseover="formore = true"
          @mouseleave="formore = false"
        >
          <div>探索更多</div>
          <div class="arrow" :class="{ arrowblue: formore }"></div>
        </div>
      </div>
      <div class="newlist">
        <div
          class="new"
          v-for="(item, index) in homelist"
          :key="index"
          @click="toNewDetail(item.id)"
        >
          <!-- <div class="nimg"><img :src="item.image+'?x-oss-process=image/resize,m_fixed,w_280'" :alt="item.image_alt"></div> -->
          <div
            class="csimg"
            :style="{
              backgroundImage:
                'url(' +
                item.image +
                '?x-oss-process=image/resize,m_fixed,w_640)'
            }"
          ></div>
          <div class="ncf ndate">{{ item.date }}</div>
          <div class="ntitle">{{ item.title }}</div>
          <div class="ncf ncontent" style="overlfow:hidden">
            {{ item.about }}
          </div>
        </div>
      </div>
    </div>
    <div class="story">
      <div>
        <img
          src="/static/img/about.jpg"
          alt="蓝鲨 Robor 智能电动摩托车"
          width="100%"
        />
      </div>
      <div class="stotips">
        <div class="stoname">鲨湾科技</div>
        <div class="stocontent">创立于 2018 年 8 月，</div>
        <div class="stocontent">
          是一家打造智能电动出行产品及服务的国际化科技公司，致力于用汽车科技重塑电动两轮车行业，
        </div>
        <div class="stocontent">
          为用户提供适用于中短途出行的高科技解决方案。
        </div>
        <div class="stobtn ">
          <button @click="reaUs" class="btn">了解我们</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper1 from '../swiper/swiper1.vue'
import utils from '../../utils/index'
export default {
  data() {
    return {
      homelist: [],
      formore: false
    }
  },
  mounted() {
    let that = this
    window.scrollTo(0, 0)
    this.$nextTick(function() {
      window.addEventListener('scroll', that.animateTxt)
    })
    this.getNews()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.animateTxt)
  },
  components: {
    Swiper1
  },
  methods: {
    animateTxt() {
      let top =
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        window.pageYOffset
      if (top <= 100) {
        this.$emit('hidenav')
      } else {
        this.$emit('shownav')
      }
    },
    toNewDetail(id) {
      // this.$router.push({path:`/newsdetail/${id}`})
      this.$router.push('/cn/newsdetail/' + id)
    },
    goProduct() {
      this.$router.push('/cn/robor')
    },
    reaUs() {
      this.$router.push('/cn/story')
    },
    expMore() {
      this.$router.push('/cn/news')
    },
    getNews() {
      this.$source
        .post('/web/api/v1/article/homepage', {
          language: this.GLOBAL.language.chinese
        })
        .then(res => {
          if (res.data.state === '00') {
            let homelist = res.data.data
            homelist.forEach((value, index) => {
              value.date = utils.getDate(value.date)
              // value.content=utils.dealArticle(value.content)
            })
            this.homelist = homelist
          }
        })
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/css/common.less';
.home {
  color: #fff;
  background: #000;
  padding-top: 60px;
  .news {
    padding: 5vw 0;
    width: 66.67%;
    margin: 0 auto;
    .title {
      display: flex;
      margin-bottom: 31px;
      align-items: center;
      h3 {
        font-size: 26px;
      }
      .more {
        display: flex;
        margin-top: 5px;
        margin-left: 20px;
        align-items: center;
        color: #666666;
        font-size: 12px;
        height: 35px;
        cursor: pointer;
        line-height: 35px;
        .arrow {
          margin-left: 12px;
          width: 8px;
          height: 8px;
          border-top: 1px solid #666;
          border-right: 1px solid #666;
          transform: rotate(45deg);
        }
        .arrowblue {
          border-top: 1px solid @colorblue;
          border-right: 1px solid @colorblue;
        }
      }
      .more:hover {
        color: @colorblue;
      }
    }
    .newlist {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      border-bottom: 1px solid rgba(31, 31, 31, 1);
      margin-bottom: 33px;
      padding-bottom: 33px;
      .new {
        width: 30%;
        cursor: pointer;
        margin-bottom: 20px;
        .nimg {
          overflow: hidden;
          margin-bottom: 18px;
          img {
            width: 100%;
          }
        }
        .csimg {
          height: 11.12vw;
          margin-bottom: 18px;
          // background-image:url(/static/img/in/kv.jpg) ;
          background-repeat: no-repeat;
          background-position: center;
          background-size: cover;
        }
        .ncf {
          font-size: 14px;
          color: #666;
        }
        .ncontent {
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          line-height: 24px;
        }
        .ntitle {
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          margin: 10px 0;
          font-size: 20px;
          line-height: 30px;
          height: 60px;
        }
        .ntitle:hover {
          color: @colorblue;
        }
      }
    }
  }
  .story {
    position: relative;
    text-align: center;
    .stotips {
      position: absolute;
      height: 230px;
      margin: auto;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      .stoname {
        font-size: 48px;
        margin-bottom: 27px;
      }
      .stocontent {
        font-size: 16px;
        color: #fff;
        line-height: 36px;
      }
      .stobtn {
        padding: 25px 0;
        button {
          box-sizing: border-box;
          width: 240px;
          font-size: 18px;
          background: rgba(0, 0, 0, 0);
          color: #fff;
          outline: none;
        }
        button:hover {
          background: #fff;
          color: #000;
        }
      }
    }
  }
}
.home img {
  display: block;
}
.btn {
  box-sizing: border-box;
  height: 45px;
  border-radius: 23px;
  line-height: 41px;
  border: 2px solid #fff;
  text-align: center;
  cursor: pointer;
}
.btn:hover {
  background: #fff;
  color: #000;
}
.swiper-button-prev {
  background-image: url('/static/img/buttonbg.png');
  background-size: 100%;
  width: 30px;
  height: 30px;
  top: 80%;
  margin-top: 12px;
  left: 70px;
}
.swiper-button-next {
  background-image: url('/static/img/buttonbg.png');
  background-size: 100%;
  width: 30px;
  height: 30px;
  top: 80%;
  margin-top: 12px;
  right: 70px;
}
@media screen and (max-width: 1640px) {
  // .fs_normal{
  //   font-size: 20px;
  // }
  // .arktm{
  //   left: 70px!important;
  // }
  .proinfo {
    width: 1080px !important;
  }
  .news {
    width: 1080px !important;
  }
  .csimg {
    height: 182px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/cn/home.vue